import React from 'react';

import './style.scss';

type CustomToastProps = {
  type?: 'success' | 'error';
  title?: string;
  description: string;
};

const CustomToast: React.FunctionComponent<CustomToastProps> = ({ type = 'error', title, description }) => {
  return (
    <div>
      {title ? <div className={type}>{title}</div> : null}
      <div>{description}</div>
    </div>
  );
};

export default CustomToast;
